import ActionSelector from '../../components/ActionSelector'
import { useModuleAction } from '../../hooks/useModuleAction'
import { type TokenAction } from './constants'
import DeleteTokenForm from './DeleteTokenForm'
import InsertTokenForm from './InsertTokenForm'
import UpdateTokenForm from './UpdateTokenForm'

export default function TokenModule() {
  const { selectedAction, selectAction, isValidAction } =
    useModuleAction('token')

  const formByAction = {
    insert: InsertTokenForm,
    update: UpdateTokenForm,
    delete: DeleteTokenForm,
  } satisfies Record<TokenAction, React.ComponentType>

  const Form = selectedAction ? formByAction[selectedAction] : null

  if (!isValidAction) {
    return <ActionSelector module='token' onSelectAction={selectAction} />
  }

  return <div className='space-y-4'>{Form && <Form />}</div>
}
